import { Card, Spinner } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

export const SnapshotRowWidget = props => {

    const { loading, children } = props;

    return (

        <Card>
            <Card.Body>
                <div className={`d-flex align-items-center ${loading ? 'justify-content-center' : ''}`}>
                    {loading ?
                        (
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">
                                    <FormattedMessage
                                        id="label.loading"
                                        defaultMessage="Loading..."
                                    />
                                </span>
                            </Spinner>
                        )
                        :
                        (
                            <>
                                {children}
                            </>
                        )
                    }
                </div>
            </Card.Body>
        </Card>
    );

};